// extracted by mini-css-extract-plugin
export default {"cars_container":"CarsPage_cars_container__sZ9nd","btn":"CarsPage_btn__2n5Zi","empty":"CarsPage_empty__JPVNw","add_new":"CarsPage_add_new__1iTm+"};